import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { tagListNoPage } from "@/service/structure";
import STree from "@/components/Tree/STree";
import identityIcon from "@/libs/identityIcon";
import OrgUserTagSelectList from "@/components/FragmentTemplate/OrgUserTagSelectList";
export default {
  name: "add_module",
  components: {
    STree,
    OrgUserTagSelectList
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    scopeList: {
      type: Array,
      default() {
        return [];
      }
    },
    checkedTitle: {
      type: String,
      default() {
        return $t("y4yv4xb", "已选择部门/成员/标签");
      }
    },
    tagVisible: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  data() {
    return {
      dataTree: [],
      checkTree: [],
      tagList: [],
      identityIcon
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.init();
      } else {
        this.clean();
      }
    }
  },
  methods: {
    /* 不显示弹窗 */
    clean() {
      this.checkTree = [];
      this.tagList = [];
    },
    getCheckTree() {
      return this.checkTree;
    },
    onSelectChangeTree(item) {
      let index = this.checkTree.findIndex(v => {
        if (item.isUserByTree) {
          if (v.isUserByTree) {
            return item.userId === v.userId;
          }
        } else {
          return item.id === v.id;
        }
      });
      if (index === -1) {
        item.isCheck = true;
        this.checkTree.push(item);
      } else {
        this.$Message.warning($t("e7dxe3", "已存在"));
      }
    },
    onSelectChangeTag(item) {
      if (this.checkTree.findIndex(v => v.tagId === item.tagId) === -1) {
        item.isCheck = true;
        item.type = "TAG";
        this.checkTree.push(item);
      } else {
        this.$Message.warning($t("e7dxe3", "已存在"));
      }
    },
    onDelete(item) {
      let index = this.checkTree.findIndex(v => {
        if (item.isUserByTree) {
          return v.userId === item.userId;
        } else if (v.orgId) {
          return v.orgId === item.orgId;
        } else if (v.tagId) {
          return v.tagId === item.tagId;
        }
      });
      if (index > -1) {
        item.isCheck = false;
        this.checkTree.splice(index, 1);
      }
    },
    async getTagList() {
      const res = await tagListNoPage();
      if (res.data && res.data.result === 0) {
        res.data.retVal.forEach(v => {
          v.name = v.tagName;
          v.isCheck = false;
        });
        this.tagList = res.data.retVal;
      }
    },
    /*
     ** 设置已勾选标签
     */
    initSetTagIsCheck() {
      let checkTree = this.checkTree;
      let tagList = this.tagList;
      tagList.forEach(v => {
        let index = checkTree.findIndex(vv => {
          if (vv.type === "TAG") {
            return vv.tagId === v.tagId;
          }
        });
        if (index > -1) {
          v.isCheck = true;
          checkTree[index] = v;
          this.checkTree = [...checkTree];
        }
      });
    },
    /*
     ** 递归
     */
    echoCheckDG(data) {
      let change = arr => {
        arr.forEach(v => {
          this.echoCheck(v);
          let children = v.children;
          if (children && children.length > 0) {
            change(children);
          }
        });
      };
      change(data);
    },
    setValue() {
      this.checkTree = [...this.scopeList];
      this.initSetTagIsCheck();
    },
    async init() {
      await this.getTagList();
      this.setValue();
    }
  }
};